import { Flame } from "lucide-react";

const PHRASES = [
    "Grenada x Jamaica roots",
    "Small-batch Ontario craft",
    "Scotch bonnet heat",
    "Allspice & smoke",
    "Launching in Ontario",
];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {PHRASES.map((p) => (
            <span key={p} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-display text-2xl font-bold uppercase tracking-wide text-nutmeg/50 sm:text-3xl">
                    {p}
                </span>
                <Flame className="h-5 w-5 shrink-0 text-bonnet/60" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div className="overflow-hidden border-y border-nutmeg/15 bg-coal py-6" data-testid="marquee-ribbon">
        <div className="flex w-max animate-marquee">
            <Row />
            <Row />
        </div>
    </div>
);

export default Marquee;
